// ── Pen localStorage helpers ──────────────────────────────────────────────────

const KEY = 'wsncode_current_pen';

// Free-plan save cap advertised on the pricing page (Home.js) — Pro removes this limit.
export const MAX_FREE_PENS = 10;

const DEFAULT_HTML = '<h1>Hello World!</h1>\n<p>Start coding here...</p>';
const DEFAULT_CSS  = 'body {\n  font-family: sans-serif;\n  padding: 20px;\n  background: #f0f0f0;\n}';
const DEFAULT_JS   = 'console.log("Hello from JS!");';

export const getSavedPen = () => {
  try {
    const saved = localStorage.getItem(KEY);
    return saved ? JSON.parse(saved) : null;
  } catch { return null; }
};

export const savePenToStorage = (pen) => {
  localStorage.setItem(KEY, JSON.stringify(pen));
};

export const clearPenStorage = () => {
  localStorage.removeItem(KEY);
};

export const getDefaultPen = () => ({
  id:    null,
  title: 'Untitled',
  html:  DEFAULT_HTML,
  css:   DEFAULT_CSS,
  js:    DEFAULT_JS,
});